// LICENSE_CODE ZON
'use strict';
/*jslint browser:true, es6:true, node:true, react:true*/

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useEffect, useState, useContext } from 'react';
import cn from 'classnames';
import etask from '/util/etask.js';
import _ from 'zutil';
import '/www/hola/pub/css/core/input.less';
import { Svg } from '../ui/svg';
import { Settings_context } from '../settings_ctx';
export const Input = props => {
  const _useContext = useContext(Settings_context),
        theme = _useContext.theme,
        theme_name = _useContext.theme_name;

  const cl = props.cl,
        round = props.round,
        _props$type = props.type,
        type = _props$type === void 0 ? 'text' : _props$type,
        name = props.name,
        auto_complete = props.auto_complete,
        on_change = props.on_change,
        tab_index = props.tab_index,
        _props$placeholder = props.placeholder,
        placeholder = _props$placeholder === void 0 ? ' ' : _props$placeholder,
        value = props.value,
        validator = props.validator,
        label = props.label,
        on_validation = props.on_validation,
        error = props.error,
        auto_focus = props.auto_focus,
        select_by_focus = props.select_by_focus,
        center = props.center,
        error_style = props.error_style,
        no_margin = props.no_margin,
        on_blur = props.on_blur,
        color = props.color,
        size = props.size,
        icon = props.icon,
        Icon = props.Icon,
        icon_size = props.icon_size,
        input_cls = props.input_cls,
        left_align_icon = props.left_align_icon,
        on_focus = props.on_focus,
        no_caret = props.no_caret,
        area_label = props.area_label,
        on_click = props.on_click,
        inputmode = props.inputmode,
        on_icon_click = props.on_icon_click,
        disabled = props.disabled,
        read_only = props.read_only;
  const is_hola2023 = theme_name == 'hola2023';
  const ref = useRef();

  const on_blur_ = () => etask(function* () {
    const validation_error = validator ? yield validator(value) : '';
    set_err(validation_error);
    if (on_validation) on_validation(validation_error);
    if (on_blur) on_blur();
  });

  const on_focus_hdl = ev => {
    if (on_focus) on_focus();
    if (select_by_focus) ev.target.setSelectionRange(0, value && value.length || 255);
  };

  const _useState = useState(error),
        _useState2 = _slicedToArray(_useState, 2),
        err = _useState2[0],
        set_err = _useState2[1];

  useEffect(() => {
    if (err != error) set_err(error);
  }, [error]);
  useEffect(() => {
    if (auto_focus && ref && ref.current) {
      setTimeout(() => {
        if (!ref.current) return;
        ref.current.focus();
        ref.current.select();
      }, 30);
    }
  }, [auto_focus]);
  const cls = cn(input_cls, 'hola_input', round && 'hola_input--round', (err || error_style) && 'hola_input--error', center && 'hola_input--center', color && `hola_input--${color}`, size && `hola_input--${size}`, (icon || Icon) && (left_align_icon ? `hola_input--has_icon_left` : `hola_input--has_icon`), icon_size && `hola_input_icon--${icon_size}`, no_caret && 'hola_input--pointer');
  const container_cls = cn(cl, 'form_field hola_input_container', is_hola2023 && 'hola_input_container--hola2023', no_margin && 'hola_input_container--no_margin', (err || error_style) && 'hola_input--with_error', no_caret && 'hola_input--no_caret_input', !!on_click && 'hola_input--pointer_for_container');
  const input_field = /*#__PURE__*/React.createElement("input", _extends({
    type: type,
    className: cls,
    ref: ref,
    autoComplete: auto_complete,
    onBlur: on_blur_,
    placeholder: placeholder,
    value: value || '',
    tabIndex: tab_index,
    name: name,
    readOnly: read_only,
    onFocus: on_focus_hdl,
    disabled: no_caret || disabled,
    "area-label": area_label,
    inputMode: inputmode,
    onChange: ev => etask(function* () {
      const v = ev.target.value;
      on_change(v, ev);

      if (props.on_change_validation === false) {
        if (validator) set_err('');
        return;
      }

      const validation_error = validator ? yield validator(v) : '';
      set_err(validation_error);
      if (on_validation) on_validation(validation_error);
    })
  }, _.pick(props, 'onKeyDown', 'onKeyPress', 'onInput')));
  const icon_cls = cn('hola_input_icon', left_align_icon && 'hola_input_icon--left', icon_size && `hola_input_icon--${icon_size}`, on_icon_click && `hola_input_icon--pointer`);
  return /*#__PURE__*/React.createElement("div", {
    className: container_cls,
    onClick: on_click
  }, label && (typeof label == 'string' ? /*#__PURE__*/React.createElement("span", {
    className: cn('lbl', is_hola2023 && cn(theme.P, theme.p5, theme.med))
  }, label) : label), /*#__PURE__*/React.createElement("div", {
    className: "hola_input_block"
  }, input_field, icon && /*#__PURE__*/React.createElement(Svg, {
    icon: icon,
    cls: icon_cls,
    on_click: on_icon_click
  }), !icon && Icon && /*#__PURE__*/React.createElement(Icon, {
    className: icon_cls
  })), err && /*#__PURE__*/React.createElement("span", {
    className: cn(is_hola2023 ? 'err_msg--hola2023' : 'err_msg')
  }, err));
};